/* Ironwood upsell — one-click bundle add-to-cart + live bundle total.
   Dependency-free. Reuses the theme's cart refresh events when present. */
(function () {
  'use strict';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' })
        .format((cents || 0) / 100);
    } catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }
  function refreshThemeCart() {
    ['cart:build', 'cart:refresh', 'cart:updated'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n));
    });
  }
  function iconCheck() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg>';
  }

  function bundleTotal(root) {
    var total = 0;
    root.querySelectorAll('[data-iw-variant]').forEach(function (el) {
      if (el.checked || el.hasAttribute('data-iw-anchor')) {
        total += parseInt(el.getAttribute('data-iw-price'), 10) || 0;
      }
    });
    var out = root.querySelector('.iw-bundle__total-value');
    if (out && out.textContent !== money(total, root.getAttribute('data-currency'))) {
      out.textContent = money(total, root.getAttribute('data-currency'));
    }
    return total;
  }
  function collectItems(root) {
    var items = [];
    root.querySelectorAll('[data-iw-variant]').forEach(function (el) {
      if (el.checked || el.hasAttribute('data-iw-anchor')) {
        items.push({ id: parseInt(el.getAttribute('data-iw-variant'), 10), quantity: 1 });
      }
    });
    return items.filter(function (i) { return i.id; });
  }
  function addBundle(root, btn) {
    var items = collectItems(root);
    if (!items.length) return;
    btn.disabled = true;
    var original = btn.innerHTML;
    btn.innerHTML = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function () {
      root.classList.add('is-added');
      btn.innerHTML = iconCheck() + ' Added to cart';
      refreshThemeCart();
      setTimeout(function () {
        btn.disabled = false; btn.innerHTML = original; root.classList.remove('is-added');
      }, 2600);
    }).catch(function () {
      btn.disabled = false; btn.innerHTML = original;
      window.location.href = '/cart';
    });
  }

  // Checkbox toggles (cheap, event-based)
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('.iw-bundle__check');
    if (cb) { var root = cb.closest('.iw-bundle'); if (root) bundleTotal(root); }
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.iw-bundle__add');
    if (btn) { e.preventDefault(); var root = btn.closest('.iw-bundle'); if (root) addBundle(root, btn); }
  });

  function init() {
    document.querySelectorAll('.iw-bundle').forEach(function (root) {
      bundleTotal(root);
      // Observe ONLY the small recommendations container, not the whole page.
      // Its callback writes the total OUTSIDE this node, so it can't re-trigger itself.
      var recs = root.querySelector('product-recommendations');
      if (recs && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () { bundleTotal(root); });
        mo.observe(recs, { childList: true });
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
